/**
 * Python API baseURL (python)
 */
export const backendHost = window.APP_CONFIG.BACKEND_HOST;
